import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { LANGS, getLang } from "../lib/flags";
import { useLanguage } from "../context/LanguageContext";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = getLang(lang);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 px-3 py-2 border border-[#C5A059]/30 hover:border-[#C5A059] transition-colors text-xs tracking-[0.15em] uppercase"
        data-testid="language-switcher-button"
      >
        <current.Flag width="18" height="12" className="shrink-0" />
        <span>{current.short}</span>
        <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-[#111822] border border-[#C5A059]/25 shadow-2xl z-50" data-testid="language-switcher-menu">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-3 text-left text-sm hover:bg-[#C5A059]/10 transition-colors ${lang === l.code ? "text-[#C5A059]" : "text-white"}`}
              data-testid={`language-option-${l.code}`}
            >
              <l.Flag width="22" height="15" />
              <span className="font-sans-body">{l.label}</span>
              <span className="ml-auto text-xs text-[#A3A9B2]">{l.short}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
